import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Companion_getInstance2gbof873kqjb4 as Companion_getInstance,
  ClassValue30nwdpwsxtf64 as ClassValue,
  get_serializableAnnotations1rie2dpj7h2ce as get_serializableAnnotations,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/VirtualType.mjs';
import { mapNotNull3b8ce5hky4k2l as mapNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  isComparableviyv6ctzm76u as isComparable,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { closePopovers1732azyb7hmuq as closePopovers } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/deprecated.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { TypeInfop1ovm2u0cge0 as TypeInfo } from './ServerFileRenderer.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_unpadded1ygmnwh0rw79t as get_unpadded,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  align3syrmjzjb5jar as align,
  textPopover3tarprbgmgxbr as textPopover,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import {
  Align_Start_getInstance48vaevgl3nrq as Align_Start_getInstance,
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
  Companion_getInstance2h9rm1uihk6zf as Companion_getInstance_0,
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_1,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { reactiveSuspendingtu9o1tcdi36e as reactiveSuspending } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { endsWith3cq61xxngobwh as endsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import {
  get_serializableProperties1162nosnaangd as get_serializableProperties,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import {
  Always_getInstance177eud73uc475 as Always_getInstance,
  RawStringContains3pup1bkmqxswn as RawStringContains,
  Conditionlbcfpsbet24r as Condition,
  StringContains1bog4sdhgv5sy as StringContains,
  Or37bzl6q9twftg as Or,
  FullTextSearch2zmuqp5auopao as FullTextSearch,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { nullElement39ujy5fzowmto as nullElement } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { serialNameFQN3cassnowfodm5 as serialNameFQN } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/SerialDescriptor.ext.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  DataClassPathAccess3qupo9g6dhbeb as DataClassPathAccess,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import { Companion_getInstance18mvmiinmr4hw as Companion_getInstance_2 } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { children3c86uuk2wm9cf as children } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerForeignKey(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())('com.lightningkite.services.data.References'), ForeignKeyRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())('com.lightningkite.services.data.MultipleReferences'), ForeignKeyRenderer_instance);
}
function getReferencesAnno($this, $receiver) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = $receiver.fieldAnnotations_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.References' || element.fqn_1 === 'com.lightningkite.services.data.MultipleReferences') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0 = asSequence($receiver.serializer_1.get_descriptor_wjt6a0_k$().get_annotations_20dirp_k$());
    // Inline function 'kotlin.sequences.find' call
    var tmp0_0 = mapNotNull(tmp_0, SerializableAnnotation$Companion$parseOrNull$ref(Companion_getInstance()));
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
        if (element_0.fqn_1 === 'com.lightningkite.services.data.References') {
          tmp$ret$4 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$4 = null;
    }
    tmp = tmp$ret$4;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SerializableAnnotation$Companion$parseOrNull$ref(p0) {
  return constructCallableReference((p0_0) => p0.parseOrNull_evcrzc_k$(p0_0), 1, 0, 167, 'parseOrNull', [p0]);
}
function ForeignKeyRenderer$form$lambda$slambda($$this$text, $value, $typeInfo) {
  return constructCallableReference(($this$reactiveSuspending, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$text;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $value;
    var tmp = yield* await_0(this_0, $completion);
    var tmp0_safe_receiver = (!(tmp == null) ? isComparable(tmp) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = yield* $($typeInfo.renderToString_1(tmp0_safe_receiver, $completion), $completion);
    }
    var tmp1_elvis_lhs = tmp_0;
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = tmp1_elvis_lhs == null ? 'None' : tmp1_elvis_lhs;
    var tmp_1 = tmp0.native_1;
    var tmp_2;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_2 = '\xA0';
    } else {
      tmp_2 = value;
    }
    tmp_1.set_content_i5lrjv_k$(tmp_2);
    return Unit_instance;
  }), 1);
}
function ForeignKeyRenderer$form$lambda$lambda$slambda($value, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(null, $completion);
    closePopovers($$this$button);
    return Unit_instance;
  }), 0);
}
function ForeignKeyRenderer$form$lambda$lambda$lambda(it) {
  return it.get__id_18jb1r_k$();
}
function ForeignKeyRenderer$form$lambda$lambda$lambda$slambda($$this$text, $typeInfo, $itemReactive) {
  return constructCallableReference(($this$reactiveSuspending, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$text;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $itemReactive;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = yield* $($typeInfo.renderToString_1(tmp$ret$0.get__id_18jb1r_k$(), $completion), $completion);
    var tmp = tmp0.native_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = value;
    }
    tmp.set_content_i5lrjv_k$(tmp_0);
    return Unit_instance;
  }), 1);
}
function ForeignKeyRenderer$form$lambda$lambda$lambda$slambda_0($value, $itemReactive, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $itemReactive;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* $value.set_revjhg_k$(tmp$ret$0.get__id_18jb1r_k$(), $completion);
    closePopovers($$this$button);
    return Unit_instance;
  }), 1);
}
function Link$_get_to_$ref_jq7esp(p0) {
  return constructCallableReference(() => p0.to_1, 0, 0, 168, VOID, [p0]);
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_to_opdqsp_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 169, VOID, [p0]);
}
function ForeignKeyRenderer$view$lambda$slambda($$this$text, $value, $typeInfo) {
  return constructCallableReference(($this$reactiveSuspending, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$text;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $value;
    var tmp = yield* await_0(this_0, $completion);
    var tmp0_safe_receiver = (!(tmp == null) ? isComparable(tmp) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = yield* $($typeInfo.renderToString_1(tmp0_safe_receiver, $completion), $completion);
    }
    var tmp1_elvis_lhs = tmp_0;
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = tmp1_elvis_lhs == null ? 'None' : tmp1_elvis_lhs;
    var tmp_1 = tmp0.native_1;
    var tmp_2;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_2 = '\xA0';
    } else {
      tmp_2 = value;
    }
    tmp_1.set_content_i5lrjv_k$(tmp_2);
    return Unit_instance;
  }), 1);
}
function ForeignKeyRenderer$cellView$lambda$slambda($$this$text, $value, $typeInfo) {
  return constructCallableReference(($this$reactiveSuspending, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$text;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $value;
    var tmp = yield* await_0(this_0, $completion);
    var tmp0_safe_receiver = (!(tmp == null) ? isComparable(tmp) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = yield* $($typeInfo.renderToString_1(tmp0_safe_receiver, $completion), $completion);
    }
    var tmp1_elvis_lhs = tmp_0;
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = tmp1_elvis_lhs == null ? '\u2014' : tmp1_elvis_lhs;
    var tmp_1 = tmp0.native_1;
    var tmp_2;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_2 = '\xA0';
    } else {
      tmp_2 = value;
    }
    tmp_1.set_content_i5lrjv_k$(tmp_2);
    return Unit_instance;
  }), 1);
}
var ForeignKeyRendererClass;
function ForeignKeyRenderer() {
  if (ForeignKeyRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Reference';
        this.REFERENCES_FQN_1 = 'com.lightningkite.services.data.References';
        this.MULTIPLE_REFERENCES_FQN_1 = 'com.lightningkite.services.data.MultipleReferences';
        this.IS_PRIMARY_KEY_FQN_1 = 'com.lightningkite.kiteui.forms.IsPrimaryKey';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_dgaouj_k$(context, module_0) {
        var tmp0_elvis_lhs = getReferencesAnno(this, context);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1.0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var anno = tmp;
        if (context.hasAnnotation_cpsd4h_k$('com.lightningkite.kiteui.forms.IsPrimaryKey'))
          return -1.0;
        var tmp1_safe_receiver = anno.values_1.get_wei43m_k$('references');
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = tmp1_safe_receiver instanceof ClassValue() ? tmp1_safe_receiver : null;
        }
        var tmp2_safe_receiver = tmp_0;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.fqn_1;
        var tmp_1;
        if (tmp3_elvis_lhs == null) {
          return -1.0;
        } else {
          tmp_1 = tmp3_elvis_lhs;
        }
        var typeName = tmp_1;
        if (module_0.typeInfo_1(typeName) == null)
          return -1.0;
        return 2.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_dgaouj_k$(context, module_0);
      }
      form_q74x24_k$(context, value, module_0) {
        var anno = ensureNotNull(getReferencesAnno(this, context));
        // Inline function 'kotlin.let' call
        var it = ensureNotNull(anno.values_1.get_wei43m_k$('references'));
        var typeName = (it instanceof ClassValue() ? it : THROW_CCE()).fqn_1;
        var tmp = ensureNotNull(module_0.typeInfo_1(typeName));
        var typeInfo = tmp instanceof TypeInfo() ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$2 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(tmp$ret$2);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          element.set_gap_jwjroq_k$(get_px(0));
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
          var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (MenuButton())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          element_0.requireClick_1 = true;
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_3 = align(element_0, Align_Start_getInstance(), Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          reactiveSuspending(element_1, ForeignKeyRenderer$form$lambda$slambda(element_1, value, typeInfo));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element_0.set_preferredDirection_gql2kx_k$(Companion_getInstance_0().belowLeft_1);
          element_0.opensMenu_gggyad_k$(($this$opensMenu) => {
            var tmp;
            if (context.serializer_1.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$()) {
              // Inline function 'com.lightningkite.kiteui.views.direct.button' call
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element = new (Button())($this$opensMenu.get_context_h02k06_k$());
              ensureOutermostElement(element);
              $this$opensMenu.willAddChild_hz2iwc_k$(element);
              text(element, 'Clear selection');
              onClick(element, VOID, VOID, VOID, ForeignKeyRenderer$form$lambda$lambda$slambda(value, element));
              element.onStartup_vrxh3i_k$();
              $this$opensMenu.addChild_2qpft2_k$(element);
              tmp = Unit_instance;
            }
            // Inline function 'com.lightningkite.kiteui.views.direct.col' call
            var this_0 = sizeConstraints($this$opensMenu, VOID, VOID, VOID, VOID, VOID, get_rem(25), get_rem(25));
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
            ensureOutermostElement(element_0);
            this_0.willAddChild_hz2iwc_k$(element_0);
            element_0.set_vertical_nuap32_k$(true);
            var $this$col = element_0;
            var textSearch = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
            var tmp0 = get_serializableAnnotations(typeInfo.serializer_1);
            var tmp$ret$22;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_0;
              if (isInterface(tmp0, Collection())) {
                tmp_0 = tmp0.isEmpty_y1axqb_k$();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$22 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element_1 = _iterator__ex2g4s.next_20eer_k$();
                if (endsWith(element_1.fqn_1, 'TextIndex')) {
                  tmp$ret$22 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$22 = false;
            }
            var hasTextIndex = tmp$ret$22;
            var items = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
              var cache = typeInfo.cache_1();
              var searchText = $this$remember.invoke_r7m7el_k$($this$col.debounce_nclnee_k$(textSearch, 500n));
              var tmp;
              if (isBlank(searchText)) {
                var tmp_0 = Always_getInstance();
                // Inline function 'kotlin.collections.listOf' call
                var tmp$ret$24 = emptyList();
                tmp = $this$remember.invoke_r7m7el_k$(cache.watch_jonktu_k$(new (Query())(tmp_0, tmp$ret$24)));
              } else {
                var tmp_1;
                if (hasTextIndex) {
                  tmp_1 = FullTextSearch().new_com_lightningkite_services_database_Condition_FullTextSearch_hz7vav_k$(searchText);
                } else {
                  var tmp0_elvis_lhs = get_serializableProperties(typeInfo.serializer_1);
                  var tmp_2;
                  if (tmp0_elvis_lhs == null) {
                    var tmp_3 = Always_getInstance();
                    // Inline function 'kotlin.collections.listOf' call
                    var tmp$ret$25 = emptyList();
                    return $this$remember.invoke_r7m7el_k$(cache.watch_jonktu_k$(new (Query())(tmp_3, tmp$ret$25)));
                  } else {
                    tmp_2 = tmp0_elvis_lhs;
                  }
                  var props = tmp_2;
                  // Inline function 'kotlin.collections.mapNotNull' call
                  // Inline function 'kotlin.collections.mapNotNullTo' call
                  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
                  // Inline function 'kotlin.collections.forEach' call
                  var inductionVariable = 0;
                  var last = props.length;
                  while (inductionVariable < last) {
                    var element = props[inductionVariable];
                    inductionVariable = inductionVariable + 1 | 0;
                    // Inline function 'kotlin.let' call
                    var it = element.get_serializer_u29zhh_k$();
                    var tmp0_elvis_lhs_0 = nullElement(it);
                    var tmp$ret$31 = tmp0_elvis_lhs_0 == null ? it : tmp0_elvis_lhs_0;
                    var serialName = serialNameFQN(tmp$ret$31.get_descriptor_wjt6a0_k$());
                    var tmp_4;
                    if (serialName === 'kotlin.String') {
                      var tmp_5 = new (DataClassPathSelf())(typeInfo.serializer_1);
                      var path = new (DataClassPathAccess())(tmp_5, isInterface(element, SerializableProperty()) ? element : THROW_CCE());
                      var tmp_6 = StringContains().new_com_lightningkite_services_database_Condition_StringContains_glssca_k$(searchText, true);
                      tmp_4 = path.mapCondition_3hl8s3_k$(tmp_6 instanceof Condition() ? tmp_6 : THROW_CCE());
                    } else if (Companion_getInstance_2().serialNames_1.contains_aljjnj_k$(serialName)) {
                      var tmp_7 = new (DataClassPathSelf())(typeInfo.serializer_1);
                      var path_0 = new (DataClassPathAccess())(tmp_7, isInterface(element, SerializableProperty()) ? element : THROW_CCE());
                      var tmp_8 = RawStringContains().new_com_lightningkite_services_database_Condition_RawStringContains_dkubqt_k$(searchText, true);
                      tmp_4 = path_0.mapCondition_3hl8s3_k$(tmp_8 instanceof Condition() ? tmp_8 : THROW_CCE());
                    } else {
                      tmp_4 = null;
                    }
                    var tmp0_safe_receiver = tmp_4;
                    if (tmp0_safe_receiver == null)
                      null;
                    else {
                      // Inline function 'kotlin.let' call
                      destination.add_utx5q5_k$(tmp0_safe_receiver);
                    }
                  }
                  var stringConditions = destination;
                  var tmp_9;
                  // Inline function 'kotlin.collections.isNotEmpty' call
                  if (!stringConditions.isEmpty_y1axqb_k$()) {
                    tmp_9 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(stringConditions);
                  } else {
                    tmp_9 = Always_getInstance();
                  }
                  tmp_1 = tmp_9;
                }
                var condition = tmp_1;
                // Inline function 'kotlin.collections.listOf' call
                var tmp$ret$36 = emptyList();
                tmp = $this$remember.invoke_r7m7el_k$(cache.watch_jonktu_k$(new (Query())(condition, tmp$ret$36)));
              }
              return tmp;
            });
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
            var this_1 = themed($this$col, FieldSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_2 = new (TextInput())(this_1.get_context_h02k06_k$());
            ensureOutermostElement(element_2);
            this_1.willAddChild_hz2iwc_k$(element_2);
            // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
            var value_0 = 'Search...';
            // Inline function 'com.lightningkite.kiteui.views.placeholder' call
            element_2.native_1.attributes_1.native_1.placeholder = value_0;
            element_2.bind_gesskf_k$(element_2.content_1, textSearch);
            element_2.onStartup_vrxh3i_k$();
            this_1.addChild_2qpft2_k$(element_2);
            // Inline function 'com.lightningkite.kiteui.views.expanding' call
            // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
            var this_2 = weight($this$col, 1.0);
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_3 = Recycler2().new_com_lightningkite_kiteui_views_l2_Recycler2_cdij9p_k$(this_2.get_context_h02k06_k$(), true, null);
            ensureOutermostElement(element_3);
            this_2.willAddChild_hz2iwc_k$(element_3);
            var tmp_1 = ForeignKeyRenderer$form$lambda$lambda$lambda;
            children(element_3, items, tmp_1, ($this$children, itemReactive) => {
              // Inline function 'com.lightningkite.kiteui.views.card' call
              // Inline function 'com.lightningkite.kiteui.views.direct.button' call
              var this_0 = themed($this$children, CardSemantic_getInstance());
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element = new (Button())(this_0.get_context_h02k06_k$());
              ensureOutermostElement(element);
              this_0.willAddChild_hz2iwc_k$(element);
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_0 = new (TextView())(element.get_context_h02k06_k$());
              ensureOutermostElement(element_0);
              element.willAddChild_hz2iwc_k$(element_0);
              // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
              var tmp = element_0.native_1;
              var tmp_0;
              // Inline function 'kotlin.text.isEmpty' call
              if (charSequenceLength('...') === 0) {
                tmp_0 = '\xA0';
              } else {
                tmp_0 = '...';
              }
              tmp.set_content_i5lrjv_k$(tmp_0);
              reactiveSuspending(element_0, ForeignKeyRenderer$form$lambda$lambda$lambda$slambda(element_0, typeInfo, itemReactive));
              element_0.onStartup_vrxh3i_k$();
              element.addChild_2qpft2_k$(element_0);
              var tmp_1 = Companion_getInstance_1().done_1;
              element.set_action_2ds022_k$(Action('Select', tmp_1, VOID, VOID, VOID, VOID, ForeignKeyRenderer$form$lambda$lambda$lambda$slambda_0(value, itemReactive, element)));
              element.onStartup_vrxh3i_k$();
              this_0.addChild_2qpft2_k$(element);
              return Unit_instance;
            });
            element_3.onStartup_vrxh3i_k$();
            this_2.addChild_2qpft2_k$(element_3);
            element_0.onStartup_vrxh3i_k$();
            this_0.addChild_2qpft2_k$(element_0);
            return Unit_instance;
          });
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          // Inline function 'com.lightningkite.kiteui.views.direct.link' call
          var this_4 = themed(element, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (Link())(this_4.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          this_4.willAddChild_hz2iwc_k$(element_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon = Companion_getInstance_1().externalLink_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = new (IconView())(element_2.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          element_2.willAddChild_hz2iwc_k$(element_3);
          element_3.set_source_3o5lkf_k$(icon);
          element_3.set_description_s1386w_k$('Open');
          element_3.onStartup_vrxh3i_k$();
          element_2.addChild_2qpft2_k$(element_3);
          var tmp = KMutableProperty0();
          var tmp_0 = Link$_get_to_$ref_jq7esp(element_2);
          var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element_2));
          element_2.invoke_bnq13k_k$(tmp_1, ($this$label) => {
            var tmp = $this$label.invoke_r7m7el_k$(value);
            var tmp0_elvis_lhs = (!(tmp == null) ? isComparable(tmp) : false) ? tmp : null;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            var id = tmp_0;
            return typeInfo.page_1(id);
          });
          element_2.onStartup_vrxh3i_k$();
          this_4.addChild_2qpft2_k$(element_2);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_q74x24_k$(context, value, module_0);
      }
      view_hsl4in_k$(context, value, module_0) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = context.fieldAnnotations_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.fqn_1 === 'com.lightningkite.services.data.References' || element.fqn_1 === 'com.lightningkite.services.data.MultipleReferences') {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp$ret$0 = tmp$ret$1;
        var anno = ensureNotNull(tmp$ret$0);
        // Inline function 'kotlin.let' call
        var it = ensureNotNull(anno.values_1.get_wei43m_k$('references'));
        var typeName = (it instanceof ClassValue() ? it : THROW_CCE()).fqn_1;
        var tmp = ensureNotNull(module_0.typeInfo_1(typeName));
        var typeInfo = tmp instanceof TypeInfo() ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.link' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Link())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = Link$_get_to_$ref_jq7esp(element);
          var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$label) => {
            var tmp = $this$label.invoke_r7m7el_k$(value);
            var tmp0_elvis_lhs = (!(tmp == null) ? isComparable(tmp) : false) ? tmp : null;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            var id = tmp_0;
            return typeInfo.page_1(id);
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          reactiveSuspending(element_0, ForeignKeyRenderer$view$lambda$slambda(element_0, value, typeInfo));
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_hsl4in_k$(context, value, module_0);
      }
      cellView_v4jtjx_k$(context, value, module_0) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = context.fieldAnnotations_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.fqn_1 === 'com.lightningkite.services.data.References' || element.fqn_1 === 'com.lightningkite.services.data.MultipleReferences') {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp$ret$0 = tmp$ret$1;
        var anno = ensureNotNull(tmp$ret$0);
        // Inline function 'kotlin.let' call
        var it = ensureNotNull(anno.values_1.get_wei43m_k$('references'));
        var typeName = (it instanceof ClassValue() ? it : THROW_CCE()).fqn_1;
        var tmp = ensureNotNull(module_0.typeInfo_1(typeName));
        var typeInfo = tmp instanceof TypeInfo() ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          reactiveSuspending(element, ForeignKeyRenderer$cellView$lambda$slambda(element, value, typeInfo));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_v4jtjx_k$(context, value, module_0);
      }
      columnWidth_a9nnq7_k$(context, module_0) {
        return 16.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_a9nnq7_k$(context, module_0);
      }
      labeledForm_jdnfre_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem_0(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance_1().info_1.resize_q1xpz0_k$(get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          ForeignKeyRenderer_instance.form_q74x24_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_jdnfre_k$(context, value, module_0, label, description);
      }
      labeledView_rlcwih_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem_0(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance_1().info_1.resize_q1xpz0_k$(get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          ForeignKeyRenderer_instance.view_hsl4in_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_rlcwih_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'ForeignKeyRenderer', VOID, VOID, [Renderer()]);
    ForeignKeyRendererClass = $;
  }
  return ForeignKeyRendererClass;
}
var ForeignKeyRenderer_instance;
function ForeignKeyRenderer_getInstance() {
  return ForeignKeyRenderer_instance;
}
//region block: init
ForeignKeyRenderer_instance = new (ForeignKeyRenderer())();
//endregion
//region block: exports
export {
  registerForeignKey as registerForeignKeytbmwo3p8dy1n,
  Link$_get_to_$ref_jq7esp as Link$_get_to_$ref_jq7esp3qoe1zqi0cyd0,
  Link$_set_to_$ref_i9gu5x as Link$_set_to_$ref_i9gu5x1thqm72zrq4pn,
};
//endregion

//# sourceMappingURL=ForeignKeyRenderer.mjs.map
